import axios from 'axios'
import {LoginResponse} from '../types/hooks/auth'

const { REACT_APP_MASTERDATAS_API_URL } = process.env

export interface Verifystatus {
    id: number
    verify_status_id: string
    verify_status_name: string
  
 
}

const handleResponseError = (error: any) => {
    //? = protect data no value
    if(error?.response?.data?.error){
        throw error.response.data.error
    }
    throw error
}

export const requestVerifystatus = async(conditions: object = {},accessToken: string): Promise<Verifystatus[]> => {
    // const data:Docstatus[] = await axios
    // .get(`${REACT_APP_MASTERDATAS_API_URL}/countrys/all?access_token=${accessToken}`,{
    //     // headers: {
    //     //     Authorization: `Bearer ${accessToken}`
    //     // }
    // })
    // .then(response => response.data)
    // .catch(error => handleResponseError(error))
    let data:Verifystatus[] = []
    data.push({
        id: 1,
        verify_status_id: "Verified",
        verify_status_name: "Verified"
    })
   

    return data
}

